/**
 * account模块接口列表
 */
import axios from './utils/https' // 导入http中创建的axios实例

const account = {
  // 判断用户名或者手机号是否重复
  existPhone (params) {
    return axios.post('/api/ManageAccount/existPhone', params)
  },
  // 登录
  login (params) {
    return axios.post('/api/token', params)
    // return axios.post('/token', JSON.stringify(params), { headers: { 'Content-Type': 'application/x-www-form-urlencoded;charset=UTF-8' } })
  },
  // 注册
  register (params) {
    return axios.post('/api/ManageAccount/register', params)
  },
  // 找回密码
  resetPwd (params) {
    return axios.post('/api/ManageAccount/ResetPwd', params)
  },
  // 修改密码
  updatePwd (params) {
    return axios.post('/api/ManageAccount/UpdatePwd', params)
  },
  // 绑定微信
  bindWeChat (params) {
    return axios.post('/api/ManageAccount/BindWeChat', params)
  },
  // 获取微信access_token
  weChatAccessToken (params) {
    return axios.post('/api/ManageAccount/WeChatAccessToken', params)
  },
  // 注销账户
  cancelAccountByPhone (params) {
    return axios.post('/api/ManageAccount/CancelAccountByPhone', params)
  },
  // 绑定微信
  cancelAccountByWeChat (params) {
    return axios.post('/api/ManageAccount/CancelAccountByWeChat', params)
  }
}

export default account
